(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header_yobi"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tocContainer = document.querySelector('.article-template__content .toc-container');
    if (tocContainer) {
      var tocHeader = tocContainer.querySelector('.toc-header');
      if (tocHeader) {
        tocHeader.addEventListener('click', function () {
          var tocContent = tocContainer.querySelector('.toc-content');
          var toggleIcon = tocContainer.querySelector('.toc-toggle-icon');
          if (tocContent && toggleIcon) {
            if (tocContent.classList.contains('show')) {
              tocContent.classList.remove('show');
              toggleIcon.classList.remove('open');
            } else {
              tocContent.classList.add('show');
              toggleIcon.classList.add('open');
            }
          }
        });
      }
    }
    var tocLinks = document.querySelectorAll('.article-template__content .toc-list a[href^="#"]');
    function getHeaderOffset() {
      if (window.innerWidth >= 989) {
        return 120;
      }
      return 100;
    }
    tocLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = this.getAttribute('href');
        var targetElement = document.querySelector(targetId);
        if (targetElement) {
          var headerOffset = getHeaderOffset();
          var elementPosition = targetElement.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
          history.pushState(null, null, targetId);
        }
      });
    });
  });
  function toggleToc() {
    var tocContainer = document.querySelector('.article-template__content .toc-container');
    if (!tocContainer) {
      return;
    }
    var tocContent = tocContainer.querySelector('.toc-content');
    var toggleIcon = tocContainer.querySelector('.toc-toggle-icon');
    if (tocContent && toggleIcon) {
      if (tocContent.classList.contains('show')) {
        tocContent.classList.remove('show');
        toggleIcon.classList.remove('open');
      } else {
        tocContent.classList.add('show');
        toggleIcon.classList.add('open');
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scg-package-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scg-package-switcher')) {
    customElements.define(
      'scg-package-switcher',
      class ScgPackageSwitcher extends HTMLElement {
        connectedCallback() {
          this.courseLabels = (this.dataset.courseLabels || '').split('|');
          this.onCourseChange = this.onCourseChange.bind(this);
          document.addEventListener('change', this.onCourseChange);
          this.update(Number(this.dataset.courseIndex || 0));
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.onCourseChange);
        }

        onCourseChange(event) {
          if (!(event.target instanceof HTMLInputElement)) return;
          const index = this.courseLabels.indexOf(event.target.value);
          if (index < 0) return;
          this.update(index);
        }

        update(index) {
          const courseLabel = this.courseLabels[index];
          if (!courseLabel) return;

          const heading = this.querySelector('[data-switcher-course-heading]');
          if (heading) heading.textContent = courseLabel;

          this.querySelectorAll('[data-package-card]').forEach((card) => {
            const variantIds = (card.dataset.variantIds || '').split('|');
            const prices = (card.dataset.prices || '').split('|');
            const compareAtPrices = (card.dataset.compareAtPrices || '').split('|');
            const images = (card.dataset.images || '').split('|');
            const variantId = variantIds[index];
            const price = Number(prices[index] || 0);
            const compareAtPrice = Number(compareAtPrices[index] || 0);
            const image = images[index] || images[0];

            if (variantId) {
              const productUrl = `/products/${encodeURIComponent(card.dataset.handle)}?variant=${variantId}`;
              card.querySelectorAll('[data-package-link]').forEach((link) => {
                link.href = productUrl;
              });
            }

            card.querySelectorAll('[data-package-course-title]').forEach((course) => {
              course.textContent = courseLabel;
            });

            const priceNode = card.querySelector('[data-package-price]');
            if (priceNode && Number.isFinite(price)) {
              priceNode.textContent = new Intl.NumberFormat('ja-JP', {
                style: 'currency',
                currency: 'JPY',
                maximumFractionDigits: 0,
              }).format(price / 100);
            }

            const compareAtPriceNode = card.querySelector('[data-package-compare-price]');
            if (compareAtPriceNode && Number.isFinite(compareAtPrice)) {
              compareAtPriceNode.textContent = new Intl.NumberFormat('ja-JP', {
                style: 'currency',
                currency: 'JPY',
                maximumFractionDigits: 0,
              }).format(compareAtPrice / 100);
            }

            const imageNode = card.querySelector('[data-package-image]');
            if (imageNode && image) {
              imageNode.src = image;
              imageNode.alt = `${imageNode.dataset.packageLabel || ''} ${courseLabel}`.trim();
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
